module.exports = __webpack_public_path__ + "media/images/planning_a_trip_to_japan/zh-hant/1/4-38943af99e0dc507623910ea173ca062.jpg";